export const APP_STATE_ACTION_TYPE_RAFFLESIA_USER = 'raff_u';

export const rafflesiaStates = {
  [APP_STATE_ACTION_TYPE_RAFFLESIA_USER]: {
    type: 'json',
    default: null,
  },
};

export const rafflesiaStateDefaultStates = {

};
